import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "cart-promo__item" };
const _hoisted_2 = { class: "my-promo__code" };
const _hoisted_3 = {
    key: 0,
    class: "my-promo__extra"
};
const _hoisted_4 = { class: "my-promo__value" };
const _hoisted_5 = {
    key: 0,
    class: "my-promo__btn"
};
const _hoisted_6 = ["data-tooltip"];
const _hoisted_7 = { class: "btn__icon" };
const _hoisted_8 = { class: "my-promo__btn" };
const _hoisted_9 = { class: "btn__icon" };
import Sprite from "../../../../components/Sprite.vue";
import Icon from "../../../../components/Icon.vue";
import CartEventBus from "../../CartEventBus";
import Code from "../../../../components/Code.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CouponListItem',
    props: {
        coupon: { type: Object, required: true },
    },
    setup(__props) {
        const props = __props;
        function removeCoupon() {
            CartEventBus.emit('coupons:remove', props.coupon.code);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["my-promo", __props.coupon.valid ? 'my-promo--valid' : __props.coupon.ghost ? 'my-promo--ghost' : 'my-promo--invalid'])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(Code, {
                            code: __props.coupon.code,
                            modifier: "promo"
                        }, {
                            default: _withCtx(() => [
                                (__props.coupon.valid)
                                    ? (_openBlock(), _createBlock(Sprite, {
                                        key: 0,
                                        name: "check"
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["code"])
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (!__props.coupon.ghost)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.coupon.amount), 1 /* TEXT */),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            (__props.coupon.status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn--4 btn--m btn--black btn--link btn--icon",
                                        "data-tooltip": __props.coupon.status
                                    }, [
                                        _createElementVNode("span", _hoisted_7, [
                                            _createVNode(Icon, { name: "info" })
                                        ])
                                    ], 8 /* PROPS */, _hoisted_6)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn--4 btn--m btn--black btn--link btn--icon",
                                    onClick: removeCoupon
                                }, [
                                    _createElementVNode("span", _hoisted_9, [
                                        _createVNode(Icon, { name: "remove" })
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
            ]));
        };
    }
});
